export default {
  'PropertyCell.Wrapper.Checkbox': ({ isSelected }, outlet) => {
    outlet({ action: 'select_row' })
  },
  'PropertyCell.Wrapper': ({ }, outlet) => {
    outlet({ action: 'view_card' })
  },
}
